"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNewebPayCreditCardRequest = instanceOfNewebPayCreditCardRequest;
exports.NewebPayCreditCardRequestFromJSON = NewebPayCreditCardRequestFromJSON;
exports.NewebPayCreditCardRequestFromJSONTyped = NewebPayCreditCardRequestFromJSONTyped;
exports.NewebPayCreditCardRequestToJSON = NewebPayCreditCardRequestToJSON;
exports.NewebPayCreditCardRequestToJSONTyped = NewebPayCreditCardRequestToJSONTyped;
/**
 * Check if a given object implements the NewebPayCreditCardRequest interface.
 */
function instanceOfNewebPayCreditCardRequest(value) {
    if (!('merchantOrderNo' in value) || value['merchantOrderNo'] === undefined)
        return false;
    if (!('amt' in value) || value['amt'] === undefined)
        return false;
    if (!('itemDesc' in value) || value['itemDesc'] === undefined)
        return false;
    if (!('returnURL' in value) || value['returnURL'] === undefined)
        return false;
    return true;
}
function NewebPayCreditCardRequestFromJSON(json) {
    return NewebPayCreditCardRequestFromJSONTyped(json, false);
}
function NewebPayCreditCardRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'merchantID': json['merchantID'] == null ? undefined : json['merchantID'],
        'merchantOrderNo': json['merchantOrderNo'],
        'amt': json['amt'],
        'itemDesc': json['itemDesc'],
        'timeStamp': json['timeStamp'] == null ? undefined : json['timeStamp'],
        'version': json['version'] == null ? undefined : json['version'],
        'expireDate': json['expireDate'] == null ? undefined : json['expireDate'],
        'returnURL': json['returnURL'],
        'notifyURL': json['notifyURL'] == null ? undefined : json['notifyURL'],
        'customerURL': json['customerURL'] == null ? undefined : json['customerURL'],
        'clientBackURL': json['clientBackURL'] == null ? undefined : json['clientBackURL'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailModify': json['emailModify'] == null ? undefined : json['emailModify'],
        'orderComment': json['orderComment'] == null ? undefined : json['orderComment'],
        'credit': json['credit'] == null ? undefined : json['credit'],
        'instFlag': json['instFlag'] == null ? undefined : json['instFlag'],
        'creditRed': json['creditRed'] == null ? undefined : json['creditRed'],
        'langType': json['langType'] == null ? undefined : json['langType'],
    };
}
function NewebPayCreditCardRequestToJSON(json) {
    return NewebPayCreditCardRequestToJSONTyped(json, false);
}
function NewebPayCreditCardRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'merchantID': value['merchantID'],
        'merchantOrderNo': value['merchantOrderNo'],
        'amt': value['amt'],
        'itemDesc': value['itemDesc'],
        'timeStamp': value['timeStamp'],
        'version': value['version'],
        'expireDate': value['expireDate'],
        'returnURL': value['returnURL'],
        'notifyURL': value['notifyURL'],
        'customerURL': value['customerURL'],
        'clientBackURL': value['clientBackURL'],
        'email': value['email'],
        'emailModify': value['emailModify'],
        'orderComment': value['orderComment'],
        'credit': value['credit'],
        'instFlag': value['instFlag'],
        'creditRed': value['creditRed'],
        'langType': value['langType'],
    };
}
